import { render, staticRenderFns } from "./MoveBtnList.vue?vue&type=template&id=48a7ae52&scoped=true&"
import script from "./MoveBtnList.vue?vue&type=script&lang=js&"
export * from "./MoveBtnList.vue?vue&type=script&lang=js&"
import style0 from "./MoveBtnList.vue?vue&type=style&index=0&id=48a7ae52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7ae52",
  null
  
)

export default component.exports